/**
 * <s-gelt-tilt>
 * Gelt coins on the Chanukah Gift Guide tilt toward a mouse pointer in 3D, with a glint that follows it.
 *   Each coin lives in a [data-gelt-item]; its face is [data-gelt-coin] (tilted via --tilt-x / --tilt-y) and its
 *   highlight is [data-gelt-glint] (positioned via --glint-x / --glint-y). The item gets data-tilting while the
 *   pointer is over it. Mouse only; touch and reduced motion leave the coins flat.
 */
const MAX_TILT = 16;

class SGeltTilt extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.handleMove = (event) => {
      if (event.pointerType !== 'mouse') return;
      const item = event.target.closest('[data-gelt-item]');
      if (!item || !this.contains(item)) return;
      const coin = item.querySelector('[data-gelt-coin]');
      if (!coin) return;
      if (this.activeItem && this.activeItem !== item) this.reset(this.activeItem);
      this.activeItem = item;

      const box = coin.getBoundingClientRect();
      const x = Math.min(Math.max((event.clientX - box.left) / box.width, 0), 1);
      const y = Math.min(Math.max((event.clientY - box.top) / box.height, 0), 1);
      item.setAttribute('data-tilting', '');
      coin.style.setProperty('--tilt-x', `${((x - 0.5) * 2 * MAX_TILT).toFixed(2)}deg`);
      coin.style.setProperty('--tilt-y', `${((0.5 - y) * 2 * MAX_TILT).toFixed(2)}deg`);
      item.style.setProperty('--glint-x', `${(x * 100).toFixed(1)}%`);
      item.style.setProperty('--glint-y', `${(y * 100).toFixed(1)}%`);
    };

    this.handleLeave = (event) => {
      const item = event.target.closest('[data-gelt-item]');
      if (!item || item.contains(event.relatedTarget)) return;
      this.reset(item);
    };

    this.addEventListener('pointermove', this.handleMove);
    this.addEventListener('pointerout', this.handleLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('pointermove', this.handleMove);
    this.removeEventListener('pointerout', this.handleLeave);
  }

  reset(item) {
    item.removeAttribute('data-tilting');
    const coin = item.querySelector('[data-gelt-coin]');
    if (coin) {
      coin.style.removeProperty('--tilt-x');
      coin.style.removeProperty('--tilt-y');
    }
    if (this.activeItem === item) this.activeItem = null;
  }
}

if (!customElements.get('s-gelt-tilt')) customElements.define('s-gelt-tilt', SGeltTilt);
